export function getEntityById(state, schemaName, id) {
  return state.entities[schemaName].byId[id];
}



// WEBPACK FOOTER //
// ./src/selectors/selectorUtils.js